import {Component, Injector, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BasePropostaComponent} from '../base-proposta';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AppComponent} from '../../../app.component';
import {CategoriaPlanoService} from '../../../core/services/categoria_plano.service';
import {CupomService} from '../../../core/services/cupom.service';
import {AutenticacaoClienteSiteService} from '../../../core/services/autenticacao_cliente_site.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {CepService} from '../../../core/services/cep.service';
import {Meta, Title} from '@angular/platform-browser';
import {DeviceDetectorService} from 'ngx-device-detector';


@Component({
    selector: 'app-esqueci-senha',
    templateUrl: './esqueci-senha.component.html',
    styleUrls: ['./esqueci-senha.component.sass']
})
export class EsqueciSenhaComponent extends BasePropostaComponent implements OnInit {

     form: FormGroup;
     formChangePassword: FormGroup;
     errorCpf: boolean;
     isCpf: boolean;
     errorEmail: boolean;
     isEmail: boolean;
     requestSend: boolean;
     requestError: boolean;
     resultEmail: string;
     token: string;
     hasToken: boolean;
    requestChancePasswordError: boolean;
    requestChancePasswordSend: boolean;
    public captchaDisabled: boolean;
    public theme: 'light' | 'dark' = 'light';
    public size: 'compact' | 'normal' = 'normal';
    public lang = 'pt-br';
    public type: 'image' | 'audio';
    public siteKey = '6LcWJW8eAAAAAN6e3qBV1_N8nApyPFWCDIJeSxgD';
    constructor(
        protected injector: Injector,
        private formBuilder: FormBuilder,
        private autenticacaoClienteSiteService: AutenticacaoClienteSiteService,
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public router: Router,
        public toast: ToastrService,
        public cepService: CepService,
        public categoriaPlanoService: CategoriaPlanoService,
        public appComponent: AppComponent,
        public route: ActivatedRoute,
        public titleService: Title,
        public meta: Meta,
        public deviceService: DeviceDetectorService
    ) {
        super(injector);
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            if (params.token) {
                this.token = params.token;
                this.hasToken = true;
                this.captchaDisabled = false;
                return;
           }
            this.captchaDisabled = true;
        });

        this.form = this.formBuilder.group({
            value: ['', Validators.required],
            recaptcha: ['', Validators.required]
        });
        this.formChangePassword = this.formBuilder.group({
            password: ['', Validators.required],
            confirmPassword: ['', Validators.required]
        });
    }

    handleSuccess(data) {
        this.captchaDisabled = false;
    }

    showError(form: FormGroup, campo) {
        return form.controls[campo].errors && !form.controls[campo].pristine;
    }

    // 76596346153
    async submit() {
        this.errorCpf = false;
        this.errorEmail = false;
        this.isCpf = false;
        this.isEmail = false;
        this.requestSend = false;
        this.requestError = false;
        if (this.form.invalid) {
            return;
        }
        this.appComponent.overlay = true;
        const value = this.form.value.value;
        const payload = (value.search('@') !== -1) ? this.sendEmail(value) : this.sendCpf(value);
        if (!payload) {
            return;
        }
        const result = await this.autenticacaoClienteSiteService.sendForgotPassword(payload);
        if (result.error) {
            if (result.status !== 409) {
                this.toast.error(result.error.description, '', {
                    timeOut: 5000
                });
            }
            this.appComponent.overlay = false;
            this.requestError = true;
            return;
        }
        this.requestSend = true;
        this.resultEmail = result.data.emailCifrado;
        this.appComponent.overlay = false;
    }

    async submitAlterPassword() {
        this.requestChancePasswordError = false;
        this.requestChancePasswordSend = false;
        if (this.formChangePassword.invalid) {
            return;
        }
        const payload = {
            email: this.getEmailToken(this.token),
            novaSenha: this.formChangePassword.value.password,
            confirmaSenha: this.formChangePassword.value.confirmPassword,
            token: this.token
        };
        const result = await this.autenticacaoClienteSiteService.forgotPassword(payload);
        if (result.error) {
            if (result.status) {
                this.toast.error(result.error.description, '', {
                    timeOut: 5000
                });
            }
            this.appComponent.overlay = false;
            this.requestChancePasswordError = true;
            return;
        }
        this.requestChancePasswordSend = true;
        this.appComponent.overlay = false;
    }
    getErrorMessage(form: FormGroup, field: string) {
        const input = form.get(field);
        return input.hasError('required') ? 'Campo obrigatório' :
            input.hasError('diferent') ? 'As senhas não correspondem.' : '';
    }

    fieldCss(form: FormGroup, campo: string) {
        let baseError = this.fieldCssClass(form, campo);
        if (this.errorCpf || this.errorEmail || this.requestError) {
            baseError = 'campo-error';
        }
        return baseError;
    }

    private sendCpf(cpf: any) {
        this.errorCpf = false;
        cpf = cpf.replaceAll('.', '');
        cpf = cpf.replace('-', '');
        if (cpf.length !== 11) {
            this.errorCpf = true;
            return null;
        }
        this.isCpf = true;
        return { cpf };
    }

    private sendEmail(email: any) {
        this.errorEmail = false;
        // tslint:disable-next-line:max-line-length
        const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        if (!regexp.test(email)) {
            this.errorEmail = true;
            return null;
        }
        this.isEmail = true;
        return { email };
    }

    verifyPassword() {
        const password = this.formChangePassword.value.password;
        const confirmPassword =  this.formChangePassword.value.confirmPassword;
        if (password !== '') {
            (confirmPassword !== password)
                ? this.formChangePassword.controls.confirmPassword.setErrors({diferent: true})
                : this.formChangePassword.controls.confirmPassword.setErrors(null);
        }

    }
}
